import * as React from 'react';
import { useMemo } from 'react';

import GradeIcon from '@/components/elements/Icon/Grade';
import TimeFrameIcon from '@/components/elements/Icon/TimeFrame';
import { EntryRacerMailParam, Race } from '@/lib/apollo/types/gen/graphql';
import { getVelodromeByCode, velodromes } from '@/lib/race/velodrome';

import {
  CenterBox,
  Container,
  Content,
  DeadLine,
  IconArea,
  LeftBox,
  RaceInfo,
  RacerName,
  RightBox,
  Times,
  VelodromeName,
} from './style';

interface TodayRacerProps {
  todayRacer: EntryRacerMailParam;
  race?: Race;
}

const TodayRacer: React.FC<TodayRacerProps> = ({ todayRacer, race }) => {
  if (!todayRacer || !race) {
    return <></>;
  }

  const velodrome = useMemo(
    () => getVelodromeByCode(todayRacer.velodromeCode),
    [todayRacer],
  );

  const hrefLink = useMemo(() => {
    if (todayRacer) {
      const targetVelodrome = velodromes.filter(
        item => item.code == todayRacer.velodromeCode,
      )[0];

      const baseLink = `${targetVelodrome.romanName}/race/${todayRacer.heldDate}/${todayRacer.raceNum}`;
      return baseLink;
    }
    return '';
  }, [todayRacer]);

  return (
    <Container>
      <Content>
        <RaceInfo to={hrefLink}>
          <LeftBox>
            <RacerName>{todayRacer.racerName}</RacerName>
          </LeftBox>
          <CenterBox>
            <VelodromeName>
              {velodrome.name}
              <IconArea>
                <GradeIcon gradeName={todayRacer.gradeName} />
              </IconArea>
              <IconArea>
                <TimeFrameIcon timeFrame={todayRacer.timeFrame} />
              </IconArea>
            </VelodromeName>
          </CenterBox>
          <RightBox>
            <Times>
              {todayRacer.raceNum}R
              <DeadLine>
                締切
                <time>{race.orderDeadline.format('HH:mm')}</time>
              </DeadLine>
            </Times>
          </RightBox>
        </RaceInfo>
      </Content>
    </Container>
  );
};

export default TodayRacer;
